<!-- 上传照片 -->

<template>
  <div class="uploadImg applyInitiation_personal">
    <div class="applyInitiation_personal_head">
      <span>上传照片</span>
      <span class="red">(必填)</span>
    </div>
    <div class="uploadImg_main">
      <div class="uploadImg_main_certificate">
        <div class="uploadImg_main_certificate_head">
          <span>证件照</span>
          <span>（1张）</span>
        </div>
        <div class="uploadImg_main_ul clearfix">
          <li>
            <input :disabled="isDisabled" type="file" @input="uploadCertificate" />
            <img :src="identificationImg" alt="" v-if="identificationImg" />
            <img src="../../../assets/image/apply/addimg.png" alt="" v-else />
            <div class="close" @click="closeIdentification">
              <img src="../../../assets/image/apply/close.png" alt="" />
            </div>
          </li>
        </div>
      </div>
      <div class="uploadImg_main_certificate">
        <div class="uploadImg_main_certificate_head">
          <span>生活照</span>
          <span>（1-5张）</span>
        </div>
        <div class="uploadImg_main_ul clearfix">
          <li v-for="(item, index) in liveImgList" :key="index">
            <img :src="item" alt="" />
            <div class="close" @click="closeLive(index)">
              <img src="../../../assets/image/apply/close.png" alt="" />
            </div>
          </li>
          <li v-if="liveImgList.length < 5">
            <input :disabled="isDisabled" type="file" @input="uploadLive" />
            <img src="../../../assets/image/apply/live.png" alt="" />
          </li>
        </div>
      </div>
      <div class="uploadImg_main_certificate liveVedio">
        <div class="uploadImg_main_certificate_head">
          <span>生活视频</span>
          <span></span>
          <!-- <span>（多个）</span> -->
        </div>
        <div class="liveVedio_list clearfix">
          <li v-for="(item, index) in 1" :key="index">
            <input :disabled="isDisabled" type="file" @change="uploadVedio" />
            <video :src="liveVedio" v-if="liveVedio" width="330" height="248"></video>
            <img src="../../../assets/image/apply/vedio.png" alt="" v-else />
            <div class="play" v-if="liveVedio">
              <img src="../../../assets/image/apply/play.png" alt="" />
            </div>
          </li>
          <li>
            <!-- <img src="../../../assets/image/apply/1.png" alt=""> -->
          </li>
        </div>
      </div>
      <div class="uploadImg_main_certificate">
        <div class="uploadImg_main_certificate_head">
          <span>艺术照</span>
          <span>（1-3张）</span>
        </div>
        <div class="uploadImg_main_ul clearfix">
          <li v-for="(item, index) in artisticImgList" :key="index">
            <img :src="item" alt="" />
            <div class="close" @click="closeArtistic(index)">
              <img src="../../../assets/image/apply/close.png" alt="" />
            </div>
          </li>
          <li v-if="artisticImgList.length < 3">
            <input :disabled="isDisabled" type="file" @input="uploadArtistic" />
            <img src="../../../assets/image/apply/addimg.png" alt="" />
          </li>
        </div>
      </div>
      <div class="uploadImg_identity">
        <div class="uploadImg_identity_head">身份证</div>
        <div class="uploadImg_identity_ul clearfix">
          <div class="uploadImg_identity_ul_left">
            <div class="uploadImg_identity_ul_top">
              <input :disabled="isDisabled" type="file" @change="uploadFront" />
              <img :src="frontImg" alt="" v-if="frontImg" />
              <img src="../../../assets/image/apply/zheng.png" alt="" v-else />
            </div>
            <div class="uploadImg_identity_ul_bot">点击上传身份证正面</div>
          </div>
          <div class="uploadImg_identity_ul_left">
            <div class="uploadImg_identity_ul_top">
              <input :disabled="isDisabled" type="file" @change="uploadReverse" />
              <img :src="reverseImg" alt="" v-if="reverseImg" />
              <img src="../../../assets/image/apply/fan.png" alt="" v-else />
            </div>
            <div class="uploadImg_identity_ul_bot">点击上传身份证反面</div>
          </div>
        </div>
      </div>
      <!-- <div class="uploadImg_identity">
              <div class="uploadImg_identity_head">学历证书</div>
              <div class="uploadImg_identity_ul clearfix">
                <div class="uploadImg_identity_ul_left">
                  <div class="uploadImg_identity_ul_top">
                    <img src="../../../assets/image/apply/1.png" alt="">
                  </div>
                </div>
                 <div class="uploadImg_identity_ul_left">
                  <div class="uploadImg_identity_ul_top">
                    <img src="../../../assets/image/apply/1.png" alt="">
                  </div>
                </div>
              </div>
            </div> -->
      <!-- <div class="uploadImg_identity">
              <div class="uploadImg_identity_head">资产信息</div>
              <div class="uploadImg_identity_ul clearfix">
                <div class="uploadImg_identity_ul_left">
                  <div class="uploadImg_identity_ul_top">
                    <img src="../../../assets/image/apply/1.png" alt="">
                  </div>
                </div>
                 <div class="uploadImg_identity_ul_left">
                  <div class="uploadImg_identity_ul_top">
                    <img src="../../../assets/image/apply/1.png" alt="">
                  </div>
                </div>
              </div>
            </div> -->
      <div class="copy" @click="handleSubmitImg" v-if="!isDisabled">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'
import { uploadFile } from '../../../util/upload'

export default {
  name: 'UploadPicture',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pictureInfo: {},

      identificationImg: '', // 证件照图片
      liveImgList: [], // 生活照图片
      liveIdList: [],
      liveVedio: '', // 生活视频
      artisticImgList: [], // 艺术照
      artisticIdList: [],
      frontImg: '', // 身份证正面
      reverseImg: '', // 身份证反面

      pictureFormData: {
        pic_ident: '',
        pic_life_photo: '',
        pic_artistic_photo: '',
        pic_video: '',
        front_pic: '',
        reverse_pic: '',
      },

      isUploadImg: '',
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadUserPicture()
  },
  methods: {
    //获取照片信息
    funLoadUserPicture() {
      this.$axios.post('/api/member/getUserPicture').then((res) => {
        this.pictureInfo.re_status = res.data.data.re_status
        if (res.data.code === 0) {
          this.pictureInfo = res.data.data

          this.liveVedio = res.data.data.pic_video_img
          this.liveImgList = res.data.data.pic_life_photo_img
          this.artisticImgList = res.data.data.pic_artistic_photo_img
          this.liveIdList = res.data.data.pic_life_photo.split(',')
          this.artisticIdList = res.data.data.pic_artistic_photo.split(',')
          this.frontImg = res.data.data.front_pic_img
          this.reverseImg = res.data.data.reverse_pic_img
          this.identificationImg = res.data.data.pic_ident_img
        }
      })
    },

    //上传证件照
    uploadCertificate: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.pictureFormData.pic_ident = result.id
      this.identificationImg = result.url
    }),
    //取消证件照
    closeIdentification() {
      this.identificationImg = ''
      this.pictureFormData.pic_ident = ''
    },
    //上传生活照
    uploadLive: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.liveIdList.push(result.id)
      this.liveImgList.push(result.url)
      this.pictureFormData.pic_life_photo = this.liveIdList.join(',')
    }),
    //取消生活照
    closeLive(index) {
      this.liveImgList.splice(index, 1)
      this.liveIdList.splice(index, 1)
      if (this.liveIdList.length == 0) {
        this.pictureFormData.pic_life_photo = ''
      } else {
        this.pictureFormData.pic_life_photo = this.liveIdList.join(',')
      }
    },
    //上传视频
    uploadVedio: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.pictureFormData.pic_video = result.id
      this.liveVedio = result.url
    }),
    //上传艺术照
    uploadArtistic: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.artisticIdList.push(result.id)
      this.artisticImgList.push(result.url)
      this.pictureFormData.pic_artistic_photo = this.artisticIdList.join(',')
    }),
    //取消艺术照
    closeArtistic(index) {
      this.artisticImgList.splice(index, 1)
      this.artisticIdList.splice(index, 1)
      if (this.artisticImgList.length == 0) {
        this.pictureFormData.pic_artistic_photo = ''
      } else {
        this.pictureFormData.pic_artistic_photo = this.artisticIdList.join(',')
      }
    },
    //上传反面照
    uploadReverse: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.pictureFormData.reverse_pic = result.id
      this.reverseImg = result.url
    }),
    //上传正面照
    uploadFront: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.pictureFormData.front_pic = result.id
      this.frontImg = result.url
    }),

    //上传图片
    handleSubmitImg: $DB(function () {
      this.$axios.post('/api/member/userPicture', this.pictureFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
